import type { ReactNode } from 'react';
import { memo } from 'react';

import Draw from './Draw';
import { DrawOptionsProvider, DrawProvider } from './store';
import type { DrawOptions } from './store/types';

const App = ({ options, placeholder }: { options: DrawOptions; placeholder?: ReactNode }) => {
  return (
    <DrawOptionsProvider options={options}>
      <DrawProvider>
        <Draw placeholder={placeholder} />
      </DrawProvider>
    </DrawOptionsProvider>
  );
};

export default memo(App);
